import { render } from "./PropertyRow.vue?vue&type=template&id=571ea27a&scoped=true&ts=true"
import script from "./PropertyRow.vue?vue&type=script&lang=ts"
export * from "./PropertyRow.vue?vue&type=script&lang=ts"

import "./PropertyRow.vue?vue&type=style&index=0&id=571ea27a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571ea27a"]])

export default __exports__